import { Role } from '../types/role.types';
import { User } from '../types/user.types';

export const MOCK_ROLES: Role[] = [
  {
    id: 'role-admin',
    name: 'Administrador',
    description: 'Acceso completo al sistema',
    isActive: true,
    isSystem: true,
    userCount: 1,
    createdAt: '2025-12-01T08:00:00.000Z',
    updatedAt: '2026-01-10T14:30:00.000Z',
    permissions: [],
  },
  {
    id: 'role-manager',
    name: 'Supervisor',
    description: 'Gestión operativa y reportes',
    isActive: true,
    isSystem: false,
    userCount: 2,
    createdAt: '2025-11-15T09:00:00.000Z',
    updatedAt: '2026-01-08T11:15:00.000Z',
    permissions: [],
  },
  {
    id: 'role-cashier',
    name: 'Cajero',
    description: 'Ventas y operaciones básicas',
    isActive: true,
    isSystem: false,
    userCount: 3,
    createdAt: '2025-11-20T10:00:00.000Z',
    updatedAt: '2026-01-05T16:20:00.000Z',
    permissions: [],
  },
];

export const MOCK_USERS: User[] = [
  {
    id: 'user-1',
    email: 'admin@villaimperial.com',
    firstName: 'Ana',
    lastName: 'Rojas',
    fullName: 'Ana Rojas',
    phone: '999-111-222',
    isActive: true,
    roles: [MOCK_ROLES[0]],
    primaryLocationId: 1,
    canSellFromOtherLocations: true,
    createdAt: '2025-12-02T10:05:00.000Z',
    updatedAt: '2026-01-11T09:40:00.000Z',
    lastModifiedBy: 'System',
  },
  {
    id: 'user-2',
    email: 'supervisor@villaimperial.com',
    firstName: 'Luis',
    lastName: 'Fernandez',
    fullName: 'Luis Fernandez',
    phone: '999-333-444',
    isActive: true,
    roles: [MOCK_ROLES[1]],
    primaryLocationId: 2,
    canSellFromOtherLocations: true,
    createdAt: '2025-12-05T12:30:00.000Z',
    updatedAt: '2026-01-09T08:20:00.000Z',
    lastModifiedBy: 'Ana Rojas',
  },
  {
    id: 'user-3',
    email: 'caja1@villaimperial.com',
    firstName: 'María',
    lastName: 'Lopez',
    fullName: 'María Lopez',
    phone: '999-555-666',
    isActive: false,
    roles: [MOCK_ROLES[2]],
    primaryLocationId: 2,
    canSellFromOtherLocations: false,
    createdAt: '2025-12-10T15:45:00.000Z',
    updatedAt: '2026-01-06T10:10:00.000Z',
    lastModifiedBy: 'Luis Fernandez',
    blockedAt: '2026-01-06T10:10:00.000Z',
    blockedBy: 'Luis Fernandez',
    blockReason: 'Usuario inactivo temporalmente',
  },
  {
    id: 'user-4',
    email: 'soporte@villaimperial.com',
    firstName: 'Carla',
    lastName: 'Mendoza',
    fullName: 'Carla Mendoza',
    phone: '999-777-888',
    isActive: true,
    roles: [MOCK_ROLES[1], MOCK_ROLES[2]],
    primaryLocationId: 3,
    canSellFromOtherLocations: true,
    createdAt: '2025-12-18T09:15:00.000Z',
    updatedAt: '2026-01-12T13:55:00.000Z',
    lastModifiedBy: 'Ana Rojas',
  },
];
